<template>
  <div>
    <!-- 等级特权 -->
    <div class="center_box">
      <p v-if="gradeLists.length != 0">等级特权</p>
      <ul v-if="gradeLists.length != 0">
        <li v-for="(n,index) in gradeLists" :key="index" class="flex-box">
          <img :src="n.levelimg" alt />
          <div>
            <div v-for="(nc,index) in n.title" :key="index" class="msg_box">{{nc.msg}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["gradeLists"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.center_box {
  width: 90%;
  margin: 0 auto;
  padding-top: 20px;
  p {
    color: #616161;
    font-size: 14px;
  }
  li {
    margin: 40px 0;
    justify-content: flex-start;
    align-items: flex-start;
    img {
      width: 50px;
      height: 20px;
      
    }
    div {
      margin-left: 20px;
      font-size: 15px;
      color: #333;
      font-weight: 600;
      .msg_box {
        margin-top: 40px;
      }
      div:nth-child(1) {
        margin-top: 0;
      }
    }
    
  }
}

</style>